import { ComponentConfig } from "@measured/puck";
import {
  ButtonGroupV2,
  ButtonGroupV2Props,
} from "@kunduz/feature-landing-pages";
import {
  cmsIcons,
  defaultComponentAlignment,
  defaultComponentAlignmentFields,
  defaultComponentSize,
  defaultComponentSizeFields,
} from "../../utils";

export interface ButtonGroupProps extends ButtonGroupV2Props {}

const ButtonGroup = ({ ...rest }: ButtonGroupProps) => {
  return <ButtonGroupV2 {...rest} />;
};

export const PuckButtonGroup: ComponentConfig<ButtonGroupProps> = {
  label: "Button Group",
  fields: {
    title: {
      type: "text",
      label: "Label",
    },
    buttons: {
      type: "array",
      label: "Buttons",
      arrayFields: {
        label: { type: "text", label: "Label" },
        url: { type: "text", label: "URL" },
        badgeIcon: { type: "select", label: "Badge Icon", options: cmsIcons },
      },
      defaultItemProps: {
        label: "Button",
        url: "#",
      },
    },
    options: {
      type: "object",
      label: "Options",
      objectFields: {
        ...(defaultComponentAlignmentFields as any),
        ...(defaultComponentSizeFields as any),
      },
    },
  },
  defaultProps: {
    title: "Title",
    buttons: [
      {
        label: "Button 1",
        url: "#",
        badgeIcon: "",
      },
      {
        label: "Button 2",
        url: "#",
        badgeIcon: "",
      },
    ],
    options: {
      ...defaultComponentSize,
      ...defaultComponentAlignment,
    },
  },
  render: (props) => <ButtonGroup {...props} />,
};
